import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { BugIcon, DogIcon, FishIcon, PersonIcon } from '@phosphor-icons/react';
import { useTranslation } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
import { useMovieStore } from '../../../stores';
import { CHARACTER_PRESET_IDS } from '../../../util/characterPresets';
const PRESET_META = {
    humanoid: { titleKey: 'toolbar.characterPresets.humanoid', icon: PersonIcon },
    animal: { titleKey: 'toolbar.characterPresets.animal', icon: DogIcon },
    turtle: { titleKey: 'toolbar.characterPresets.turtle', icon: BugIcon },
    octopus: { titleKey: 'toolbar.characterPresets.octopus', icon: FishIcon },
};
/**
 * Preset karakter ekleme menüsü. Seçim, Stage'in sahneye yazacağı bir
 * istek olarak store'a düşer; karakter sahne ortasına group olarak gelir.
 */
export function CharacterTools() {
    const { t } = useTranslation();
    const requestCharacterInsert = useEditorStore((s) => s.requestCharacterInsert);
    const currentScene = useMovieStore((s) => s.currentScene);
    return (_jsx("div", { className: "character-tools", children: _jsxs(DropdownMenu.Root, { children: [_jsx(DropdownMenu.Trigger, { children: _jsxs(Button, { variant: "soft", radius: "none", size: "3", className: "character-tools-trigger", "aria-label": t('toolbar.characters'), disabled: !currentScene, children: [_jsx(PersonIcon, { "aria-hidden": "true" }), _jsx(CaretDownIcon, { "aria-hidden": "true", className: "character-tools-chevron" })] }) }), _jsx(DropdownMenu.Content, { variant: "soft", size: "2", align: "start", sideOffset: 4, children: CHARACTER_PRESET_IDS.map((preset) => {
                        const meta = PRESET_META[preset];
                        const Icon = meta.icon;
                        return (_jsxs(DropdownMenu.Item, { onSelect: () => requestCharacterInsert(preset), children: [_jsx(Icon, { "aria-hidden": "true" }), t(meta.titleKey)] }, preset));
                    }) })] }) }));
}
